import { Slot } from "@radix-ui/react-slot";
import { AnimatePresence, motion } from "framer-motion";
import { forwardRef } from "react";

import { buttonVariants } from "@/components/buttons/buttonVariants";
import type { ButtonProps } from "@/components/buttons/types";
import { Spinner } from "@/components/ui/Spinner";
import { cn } from "@/utils/cn";

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant,
      size,
      testId,
      dataTutorial,
      ariaDescribedby,
      asChild = false,
      loading = false,
      disabled = false,
      children,
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        disabled={disabled || loading}
        data-testid={testId}
        data-tutorial={dataTutorial}
        aria-describedby={ariaDescribedby}
        {...props}
      >
        {children}
        <AnimatePresence mode="wait">
          {loading !== undefined && loading && (
            <motion.div
              key="spinner"
              className="ml-2 flex items-center"
              initial={{ opacity: 0, scale: 0, x: -10 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.2 }}
            >
              <Spinner />
            </motion.div>
          )}
        </AnimatePresence>
      </Comp>
    );
  }
);

Button.displayName = "Button";
